module.exports = __webpack_public_path__ + "static/media/read_content_aloud_bengali.cd4145da.mp3";